import { render, staticRenderFns } from "./DispensaryManagerPro.vue?vue&type=template&id=af9fd97c&scoped=true&"
import script from "./DispensaryManagerPro.vue?vue&type=script&lang=js&"
export * from "./DispensaryManagerPro.vue?vue&type=script&lang=js&"
import style0 from "./DispensaryManagerPro.vue?vue&type=style&index=0&id=af9fd97c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9fd97c",
  null
  
)

export default component.exports